(function() {
    var eventExhibitionListTemplate =
        '<li class="swiper-slide">'+
        '   <div class="list-inner">'+
        '       <a href="{{targetUrl}}" target="_self">'+
        '           <span class="thumb">'+
        '               <img src="{{imageUrl}}" alt="{{title}}" aria-hidden="true">'+
        '           </span>'+
        '       </a>'+
        '       <div class="info">'+
        '           <a href="{{targetUrl}}" class="tit" target="_self">'+
        '               <em></em>'+
        '               <span class="blind">{{title}}</span>'+
        '               <p>{{title}}</p>'+
        '           </a>'+
        '           <p class="date"><span class="blind">이벤트 기간</span>{{startDate}} ~ {{endDate}}</p>'+
        '       <div>'+
        '   <div>'+
        '</li>';

    var storyListTemplate =
        '<li class="swiper-slide">'+
        '   <div class="list-inner">'+
        '       <a href="{{targetUrl}}" target="_self">'+
        '           <span class="thumb">'+
        '               <img src="{{imageUrl}}" alt="{{title}}" aria-hidden="true">'+
        '           </span>'+
        '       </a>'+
        '       <div class="info">'+
        '           <a href="{{targetUrl}}" class="tit" target="_self">'+
        '               <em>{{contentsName}}</em>'+
        '               <span class="blind">{{title}}</span>'+
        '               <p>{{title}}</p>'+
        '           </a>'+
        '       <div>'+
        '   <div>'+
        '</li>';

    var thinQMain = {
        init: function(){
            var self = this;

            self.settings();

            vcui.require(['libs/slick-1.9.0.min', 'ui/pagination'], function () {
                self.bindEvents();
                self.modelSearchInit();
            });
            self.requestEventNewsList();
        },
        settings: function(){
            var self = this;
            self.$thinqMain = $('.new-thinq');

            //검색팝업
            self.$searchPopup  = $('#popupSearchMachine');
            self.$autoComplete = $('#searchAutoComplete');
            self.$searchSticky = self.$searchPopup.find('.search-sticky-wrap');
            self.$searchSelect = self.$searchSticky.find('.ui_selectbox');
            self.$searchDel = self.$searchSticky.find('.btn-delete');
            self.$btnInputSearch = self.$searchSticky.find('.btn-search');
            self.$searchInput = self.$searchSticky.find('.input-wrap input[type="text"]');
            self.$searchIntro = self.$searchPopup.find('.intro-message');
            self.$prdResult = self.$searchPopup.find('.product-result-wrap');
            self.$prdTotalCount = self.$prdResult.find('.prd-result-text');
            self.$nodata = self.$searchPopup.find('.no-data-message');
            self.$searchDesc = self.$autoComplete.find('.search-desc');
            
            self.$eventBox = $('#eventBoxDiv');
            self.$eventBoxUl = $('#eventBoxUl');
            self.$newsBox = $('#newsBoxDiv');
            self.$newsBoxUl = $('#newsBoxUl');
            
        },
        bindEvents: function(){
            var self = this;

            //페이징 이벤트 실행
            self.$pagination = self.$searchPopup.find('.pagination').vcPagination({scrollTop : 'noUse'});

            //검색팝업: 검색어 삭제
            self.$searchDel.on('click', function(e){
                self.$searchInput.val('');
                $(this).hide();
            })

            //검색팝업: 검색 실행
            self.$btnInputSearch.on('click', function(e){
            	var categoryId = '';
                var searchKeyword = self.$searchInput.val();
                self.requestModelData({"categoryId":categoryId,"keyword":searchKeyword,"page": 1});
            })
            
            //검색팝업: 검색어 입력
            self.$searchInput.on('keydown', function(e){
            	var categoryId = '';
                var searchKeyword = self.$searchInput.val();

                if( e.keyCode == 13) {
                    self.requestModelData({"categoryId":categoryId,"keyword":searchKeyword,"page": 1});
                }
            })            

            //검색팝업: 검색어 입력 / 검색어 자동완성
            self.$searchInput.on('input', function(e){
                var searchKeyword = self.$searchInput.val();
                if( searchKeyword.length > 0 ){
                    self.$searchDel.show();
                } else {
                	self.modelSearchInit();
                }
                
                var reg = /[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/ ]/gim;
                var searchVal = this.value.trim();
                var searchTestVal = searchVal.replace(reg, "");
                
                //검색팝업: 자동완성 4글자부터 실행
                if ( searchTestVal != self.searchValchk && searchTestVal.length > 3 ) {
                	self.requestAutoCompleteData({"keyword":searchKeyword});
                	self.$searchValchk = searchTestVal; 
                } else {
                	self.searchSwap('.intro-message');
                }
            })
            
            //검색팝업: 페이징 넘버 클릭
            self.$pagination.on('page_click', function(e, data) {
            	var categoryId = '';
                var searchKeyword = self.$searchInput.val();
                e.preventDefault();
                self.requestModelData({"categoryId":categoryId,"keyword":searchKeyword,"page": data});
            });

            //검색팝업: 닫기
            self.$searchPopup.on('modalhide', function(e){
                self.modelSearchInit();
            })
        },
        modelSearchInit: function(){
            var self = this;
            
            self.$searchValchk = '';
            self.$searchInput.val('');
            self.$searchDel.hide();
            self.searchSwap('.intro-message');
        },
        swapContent: function(target, targetArray, $parent){
            var self = this;
            if( targetArray && targetArray.length > 0 && target){
                targetArray.forEach(function(item){
                    var $currentTarget = $parent && parent != "" ? $parent.find(item) : $(item);
                   
                    if( item == target ) {
                        $currentTarget.addClass('is-active');
                    } else {
                        $currentTarget.removeClass('is-active');
                    }
                })
            }
        },
        searchSwap: function(target){
            var self = this;
            var contArray = ['.intro-message', '.product-result-wrap', '.no-data-message', '.auto-complete'];

            self.swapContent(target, contArray, self.$searchPopup);
        },
        requestModelData: function(param){
            var self = this;
            var ajaxUrl = self.$searchPopup.data('ajaxUrl');
            var listTemplate =
            '<li>' +
            '   <div class="icon-wrap"><i class="icon icon-{{imgname}}"><span class="blind">{{categoryName}} 아이콘</span></i></div>' +
            '   <div class="text">' +
            '			{{#if highCategoryName}}' +
            '       		<span class="name"> {{highCategoryName}} &gt; {{categoryName}}</span>' +
            '			{{#else}}' +
            '       		<span class="name"> {{categoryName}}</span>' +		
            '			{{/if}}' +
            '      	<span class="serial-num">{{#raw text}}</span>' +
            '   </div>' +
            '</li>';
            
            lgkorUI.showLoading();
            lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                if( result.status == "success") {
                    var data = result.data;

                    var searchedValue = param.keyword;
                    
                    if(data.listData.length > 0) {
                        //리스트 페이지 노출
                        var html = "";

                        data.listData.forEach(function(item){
                            if( item.categoryName != "undefined" && item.categoryName != "" && item.imgname != "undefined" && item.imgname != "" && item.salesModelCode != "undefined" && item.salesModelCode != "") {
                            	if (data.listData.length == 1 && param.auto == "Y") {
	                        		var inputText = item.salesModelCode
	                        	} else {
	                        		//대소문자 상관없이 비교 및 강조 표시위해 중복 비교 후 index 정보로 substring
	                        		var regExpIndex = item.salesModelCode.toUpperCase().indexOf(searchedValue.toUpperCase());
	                        		var regExpText 	= item.salesModelCode.substring(regExpIndex, regExpIndex + (searchedValue.length));
	                            	var replaceText = '<em>' + regExpText + '</em>';
	                            	var inputText 	= vcui.string.replaceAll(item.salesModelCode,regExpText,replaceText)
	                        	}
                        	
	                            html += vcui.template(listTemplate, {
	                            	imgname			: item.imgname,
	                            	categoryName	: item.categoryName,
	                            	highCategoryName: item.highCategoryName,
	                            	text: inputText
	                            });
                            }
                        })
                        self.$prdTotalCount.find('em').text(data.listPage.listCount)
                        self.$prdResult.find('.prd-result-lists').empty().append(html);
                        self.$pagination.vcPagination('setPageInfo', data.listPage)
                        self.searchSwap('.product-result-wrap')
                    } else {
                        //nodata 호출
                        self.searchSwap('.no-data-message');
                    }
                    lgkorUI.hideLoading();
                } else {
                    self.searchSwap('.no-data-message')
                    lgkorUI.hideLoading();
                }
            })
        },
        requestAutoCompleteData: function(param){
            var self = this;
            var ajaxUrl = self.$autoComplete.data('ajaxUrl');
            
            var srcListTemplate =
                '<li>' +
                '	<button type="button" class="btn-prd" data-content="{{salesModelCode}}">' +
                '   	<div class="icon-wrap"><i class="icon icon-{{imgname}}"><span class="blind">{{categoryName}} 아이콘</span></i></div>' +
                '   	<div class="text">' +
                '			{{#if highCategoryName}}' +
                '       		<span class="name"> {{highCategoryName}} &gt; {{categoryName}}</span>' +
                '			{{#else}}' +
                '       		<span class="name"> {{categoryName}}</span>' +		
                '			{{/if}}' +
                '       	<span class="serial-num">{{#raw text}}</span>' +
            	'   	</div>' +
                '   </button>' +
                '</li>';
            
            lgkorUI.requestAjaxData(ajaxUrl, param, function(result){
                if( result.status == "success") {
                    var data = result.data;
                    
                    var searchedValue = param.keyword;
                    
                    if(data.listData.length > 0) {
                        //리스트 페이지 노출
                        var html = "";
                        
                        data.listData.forEach(function(item){
                            if( item.categoryName != "undefined" && item.categoryName != "" && item.imgname != "undefined" && item.imgname != "" && item.salesModelCode != "undefined" && item.salesModelCode != "") {
                            	//대소문자 상관없이 비교 및 강조 표시위해 중복 비교 후 index 정보로 substring 
                            	var regExpIndex = item.salesModelCode.toUpperCase().indexOf(searchedValue.toUpperCase());
                            	var regExpText = item.salesModelCode.substring(regExpIndex, regExpIndex + (searchedValue.length));
                            	var replaceText = '<em>' + regExpText + '</em>';
                            	
                            	html += vcui.template(srcListTemplate, {
                                	salesModelCode	: item.salesModelCode,
                                	imgname			: item.imgname,
                                	categoryName	: item.categoryName,
                                	highCategoryName: item.highCategoryName,
                                	text: vcui.string.replaceAll(
                                        item.salesModelCode,
                                        regExpText,
                                        replaceText
                                      )
                                	} 
                                );
                                
                            }

                        })
                        
                        //자동 완성리스트 단건 일 시에 추가 타이핑 유도 문구 비활성화
                        data.listData.length == 1 ? self.$searchDesc.hide() : self.$searchDesc.show();  
                        
                        self.$prdResult.find('.prd-result-lists').empty().append(html);
                        
                        //검색팝업: 자동완성 리스트 중 1건 클릭
                        self.$autoComplete.find('.btn-prd').on('click', function(e){
                        	var categoryId = '';
                        	var searchKeyword = e.currentTarget.dataset.content;
                        	
                        	self.$searchInput.val(searchKeyword);
                        	self.requestModelData({"categoryId":categoryId,"keyword":searchKeyword,"page": 1,"auto": "Y"});
                        })
                        
                        //쿼리도는 중 검색 창이 비워졌을 경우 intro-message로 회귀 / 화면 점멸 방지용
                        var searchKeyword = self.$searchInput.val();
                        searchKeyword.length > 3 ? self.searchSwap('.auto-complete') : self.searchSwap('.intro-message'); 
                        
                    } else {
                        //nodata 호출
                        self.searchSwap('.no-data-message');
                    }
                } else {
                    self.searchSwap('.no-data-message')
                }
            })
        },
        requestEventNewsList: function () {
            var self = this;
            var ajaxUrl = self.$eventBox.data('ajaxEventUrl');
            lgkorUI.requestAjaxData(ajaxUrl, {}, function(resultEvent) {
                if(resultEvent.status === "success") {
                    var eventList = resultEvent.data;
                    ajaxUrl = self.$eventBox.data('ajaxNewsUrl');
                    lgkorUI.requestAjaxData(ajaxUrl, {}, function (resultNews) {
                        if (resultNews.status === "success") {
                            var newsList = resultNews.data;
                            if (eventList.length > 0 || newsList.length > 0) {
                                self.$eventBox.find('div.tit-box').show();
                                if (eventList.length > 0) {
                                    self.$eventBox.find('div.medium-arrow-slide').show();
                                    eventList.forEach(function (item, index) {
                                        self.$eventBoxUl.append(vcui.template(eventExhibitionListTemplate, item));
                                    });
                                }
                                if (newsList.length > 0) {
                                    self.$newsBox.show();
                                    newsList.forEach(function (item, index) {
                                        self.$newsBoxUl.append(vcui.template(storyListTemplate, item));
                                    });
                                }
                            }
                        }
                    });
                }
            });
        }
    };
    thinQMain.init();

})();